import { AvatarClassKey } from '@material-ui/core/Avatar';

const MuiAvatar = (): Partial<Record<AvatarClassKey, unknown>> => ({
    root: {
        width: 32,
        height: 32,
        '&$rounded': {
            borderRadius: 6,
        },
    },
});

export default MuiAvatar;
